// A simpler version inspired by $.numberFormat
export const numberFormat = (
  number,
  decimals,
  decimalSeparator,
  thousandsSeparator
) => {
  number = number.toFixed(decimals)
  let nstr = number.toString()
  nstr += ''
  let x = nstr.split('.')
  let x1 = x[0]
  let x2 = x.length > 1 ? decimalSeparator + x[1] : ''
  let rgx = /(\d+)(\d{3})/
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + thousandsSeparator + '$2')
  }
  return x1 + x2
}

export const formatPriceWithLocalizedCurrency = (price, locale, currency) => {
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
  })
    .format(price)
    .replace(',', '.')
}

const _isNumerical = (object) => {
  object = object - 0
  return object
}

export const camelize = (string) => {
  if (_isNumerical(string)) {
    return string
  }
  string = string.replace(/[\-_\s]+(.)?/g, function (match, character) {
    return character ? character.toUpperCase() : ''
  })
  // 1st char is always lowercase
  return string.substr(0, 1).toLowerCase() + string.substr(1)
}

export const isEmail = (email) => {
  const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i

  return expression.test(String(email).toLowerCase())
}

export const isPhoneNumber = (phone_number) => {
  const expression = /^\+?[0-9\-\(\)\. ]{8,}$/i

  return expression.test(String(phone_number).toLowerCase())
}

export const areObjectsEqual = (obj1, obj2) => {
  const obj1Keys = Object.keys(obj1)
  const obj2Keys = Object.keys(obj2)

  if (obj1Keys.length !== obj2Keys.length) {
    return false
  }

  for (let objKey of obj1Keys) {
    if (obj1[objKey] !== obj2[objKey]) {
      return false
    }
  }

  return true
}
